<div class="checkin">
	<h1 class="checkin__venue-title">{{ venue.name }}</h1>
	<button class="checkin__btn checkin__btn--primary" (click)="clickHistory()">Histórico</button>
</div>
